<template>
  <div class="border px-3 py-2 AuditEvent">
    <div class="relative pb-4">
      <span class="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
      <div class="relative flex space-x-3">
        <EventTypeIcon :type="page" :event="event"/>

        <div class="flex-1 min-w-0 grid grid-cols-12 pt-1.5">
          <AuditMetaInfo
            :page="page"
            :item-id="itemId"
            :event="event"
            :user="user"
            :item-name="itemName"
          />

          <EventChanges :new-values="newValues" :old-values="oldValues"/>

          <div class="whitespace-nowrap text-right text-xs text-gray-500">
            <time datetime="2020-09-20" class="ske">{{ humanReadable || 'ashtastastashta' }}</time>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import EventTypeIcon from "./EventTypeIcon"
import AuditMetaInfo from "./AuditMetaInfo"
import EventChanges from "./EventChanges"

import { format } from 'date-fns'

export default {
  components: {
    EventTypeIcon,
    AuditMetaInfo,
    EventChanges,
  },
  props: {
    item: Object,

    createdAt: String,
    event: String,
    itemId: String,
    newValues: Object,
    oldValues: Object,
    user: Object,
    page: String,
    itemName: String,
    uid: String,
    url: String,
  },
  computed: {
    humanReadable() {
      const date = this.createdAt
      try {
        return date && format(new Date(date), "dd-MM-yyyy HH:mm")
      } catch (err) {
        return date
      }
    },
  },
}

</script>

<style scoped>

.AuditEvent {
  border-color: rgb(240,240,240) !important;
  border-top-width: 0px !important;
  border-left-width: 0px !important;
  border-right-width: 0px !important;
}

</style>

